<template>
  <div class="task-addItem">
    <div class="steps">
      <div class="title">
        <i class="icon icon-caidangongneng"></i>
        <span>{{ $t('asm_offlineService_addItem.xia_fa_shu_ju') }}</span>
      </div>
      <t-step v-model="tabActive" :list="stepList" @change="changeStep"></t-step>
    </div>
    <div class="warpper">
      <!-- 如果是升级固件的话 第三步要用到第二步绑定的固件id -->
      <select-device
        v-if="tabActive===1"
        :data="serviceModemInfo"
        :serviceModemId="serviceModemId"
        @success="syncRecordSave"
        @previous="previous"
      ></select-device>

      <!-- data: "600382507996139520" -->
      <!-- vcu  modem -->
      <!--如果是serviceType==='3'升级固件  选择固件-->
      <offline-service-command
        v-if="tabActive===2"
        :serviceModemId="serviceModemId"
        :serviceRecordId="serviceRecordId"
        :data="serviceModemInfo"
        @success="nextStep"
        @previous="previous"
      ></offline-service-command>


    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tStep from '@/components/step.vue';
// import firmwareTaskInfo from './firmwareTask_info.vue';
// import firmwareTaskInfo from './firmwareTask_info_copy.vue';

// 录入指令
import offlineServiceCommand from './offline_service_command';
import selectDevice from './offlineService_select_device';

export default {
  name: 'offlineService_addItem',
  components: { offlineServiceCommand, selectDevice, tStep, },
  computed: {
    // totalAmount: function () {
    //   return this.normalItemList.reduce((sum, next) => sum + next.itemAmount, 0);
    // },
    // totaltaxAmount: function () {
    //   return this.normalItemList.reduce((sum, next) => sum + next.taxAmount, 0);
    // },
    stepList() {
      return [
        {
          label: 1,
          value: 1,
          title: this.$t('asm_offlineService_addItem.xuan_ze_she_bei'),
          // subTitle: '填写任务基本信息'
        },
        {
          label: 2,
          value: 2,
          title: this.$t('asm_offlineService_addItem.xzxfzl'),
          subTitle: this.$t('asm_offlineService_addItem.lrrwzl')
        },

      ];
    }
  },
  data() {
    return {
      provide: true,
      visible: false,
      normalItemList: [],
      tabActive: 1,


      serviceModemId: '',
      // 记录ID 600382507996139520
      serviceRecordId: '',
      serviceType: '',
      commandMode: '', // commandMode  1-服务.提示确认，2-服务.状态更改，3-服务.弹框录入，4-配置.表单录入，5-配置.数据存档，6-配置.历史选择
      topicCode: '',

      // 第一步的数据用来共享
      serviceModemInfo: {
      },
      productList: [],
      // 第二步

      // 第二步固件id


      isLoadingVersion: false,
      versionList: [],
      totalRowsVersion: null,
      versionListSelect: [],
      tableColumnVersion: null,
    };
  },
  mounted() {
    // 获取id   有去获取详情 无就新增
    this.serviceModemId = this.getJump('serviceModemId');
    this.getModemInfo();

  },
  methods: {
    // 初始化
    nextStep: function (num) {
      this.tabActive = num;
      // if (num === 3) {
      //   this.tabActive = 3;
      // }
    },
    previous: function () {
      this.tabActive = --this.tabActive;
    },
    // 编辑的时候点击步骤
    changeStep: function (arg) {
      if (this.edit) {
        this.tabActive = arg.value;
      }
    },
    syncRecordSave(serviceRecordId) {
      this.serviceRecordId = serviceRecordId;
      this.tabActive = 2;
    },
    // 获取固件信息
    getModemInfo: function () {
      this.$getJSON(`${apis.serviceModemInfo}/${this.serviceModemId}`).then((res) => {
        this.serviceModemInfo = res.data || {};
      });
    },

  }
};
</script>

<style lang="scss">
@import "style/colors.scss";
.task-addItem {
  // display: flex;
  // height: 100%;
   height: 100%;
    position: relative;
    overflow: auto;
  .steps {
    // height: 100%;
    // width: 220px;
    // background: #f9f9fd;
    position: absolute;
    left: 0;
    top: 0;
    width: 220px;
    bottom: 0;
    background-color: #f9f9fd;
    .title{
      height: 70px;
      line-height: 70px;
      padding-left: 18px;
      font-size:14px;
      font-weight:bold;
      color:rgba(57,70,104,1);
      .icon{
        color: #0D9AE0;
        // color: $main-color;
        font-size: 13px;
        margin-right:10px;
      }
    }
  }
  .warpper {
    // flex: 1;
    // height: 100%;
    // background-color: #ffffff;
     background-color: #ffffff;
    margin-left: 220px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    .content {
      display: flex;
      flex-direction: column;
      height: 100%;
      .content-box {
        flex: 1;
        padding: 24px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
      }
      .btn-group {
        border-top: 1px solid #eef2f8;
        padding: 16px 0 16px 24px;
        height: 60px;
        z-index: 1;
        -webkit-box-flex: 0;
        flex: 0 0 60px;
      }
    }
  }
}
// 步骤条
.steps {
  display: flex;
  flex: 0 0 220px;
  padding: 20px 0;
  overflow: hidden;
  flex-direction: column;
  .steps-item {
    flex: 1;
    .steps-item-head {
      position: relative;
      width: 100%;
      color: #8c8c8c;
      border-color: #8c8c8c;
      text-align: center;
      .line {
        position: relative;
        border-color: inherit;
        background-color: #d3d3d3;
        width: 100%;
        .line-left {
          left: 0;
          // right: -50%;
          height: 2px;
          top: 11px;
          position: absolute;
          border-color: inherit;
          background-color: #d3d3d3;
          background-color: inherit;
          width: 50%;
        }
        .line-rigth {
          // left: 50%;
          left: 50%;
          height: 2px;
          top: 11px;
          position: absolute;
          border-color: inherit;
          background-color: #d3d3d3;
          background-color: inherit;
          width: 50%;
        }
      }
      .icon {
        position: relative;
        z-index: 1;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        background: #eff0f3;
        transition: 0.15s ease-out;
        border-radius: 50%;
        border: 1px solid;
        border-color: inherit;
        color: #999;
      }
    }
    .steps-item-main {
      text-align: center;
      .title {
        margin-top: 15px;
        color: #999;
      }
    }
  }
  .steps-item.on {
    flex: 1;
    .steps-item-head {
      color: #00afff;
      border-color: #00afff;
      .line {
        background-color: #00afff;
      }
      .icon {
        background: #00afff;
        color: #fff;
      }
    }
    .steps-item-main {
      text-align: center;
      .title {
        margin-top: 15px;
        color: #999;
      }
    }
  }

  .steps-item:first-of-type {
    .line {
      .line-left {
        display: none;
      }
    }
  }
  .steps-item:last-of-type {
    .line {
      .line-rigth {
        display: none;
      }
    }
  }
}
</style>
